import React from "react";
import styled from "styled-components";

export default function OfficeLocations() {
  return (
    <OfficeContainer>
      {/* US Office */}
      <OfficeCard className="whiteBg radius8 shadow">
        <OfficeHeader>
          <FlagIcon>🇺🇸</FlagIcon>
          <h3 className="font20 extraBold">USA Office</h3>
          <LocationBadge>Headquarter</LocationBadge>
        </OfficeHeader>
        
        <OfficeDescription className="font13">
          Proudly registered in Denver, Colorado, USA — beginning our journey to serve clients worldwide with a commitment to growth and innovation.
        </OfficeDescription>
      
        <ContactInfo className="font13">
          <ContactItem>
            <span className="contact-label">📧 Email:</span>
            <span className="contact-value">contact@ortecso.com</span>
          </ContactItem>
          {/* <ContactItem>
            <span className="contact-label">📞 Phone:</span>
            <span className="contact-value">+1 (555) 123-4567</span>
          </ContactItem> */}
          <ContactItem>
            <span className="contact-label">🏢 Address:</span>
            <span className="contact-value">Colorado, USA</span>
          </ContactItem>
        </ContactInfo>
      </OfficeCard>

      {/* Pakistan Office */}
      <OfficeCard className="whiteBg radius8 shadow">
        <OfficeHeader>
          <FlagIcon>🇵🇰</FlagIcon>
          <h3 className="font20 extraBold">Pakistan Office</h3>
          <LocationBadge>Development Hub</LocationBadge>
        </OfficeHeader>
        
        <OfficeDescription className="font13">
          Our team is based in Islamabad, Pakistan — delivering quality services and innovative solutions to clients worldwide.
        </OfficeDescription>
      
        <ContactInfo className="font13">
          <ContactItem>
            <span className="contact-label">📧 Email:</span>
            <span className="contact-value">contact@ortecso.com</span>
          </ContactItem>
          <ContactItem>
            <span className="contact-label">📞 Phone:</span>
            <span className="contact-value">+92-3265224929</span>
          </ContactItem>
          <ContactItem>
            <span className="contact-label">🏢 Address:</span>
            <span className="contact-value">Islamabad, Pakistan</span>
          </ContactItem>
        </ContactInfo>
      </OfficeCard>
    </OfficeContainer>
  );
}

const OfficeContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 30px;
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 20px;
  }
`;

const OfficeCard = styled.div`
  padding: 20px;
  text-align: left;
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 30px rgba(0,0,0,0.1);
  }
`;

const OfficeHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 15px;
  flex-wrap: wrap;
`;

const FlagIcon = styled.span`
  font-size: 24px;
`;

const LocationBadge = styled.span`
  background: #7620ff;
  color: white;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: bold;
`;

const OfficeDescription = styled.p`
  line-height: 1.6;
  color: #666;
  margin-bottom: 20px;
  padding: 0;
`;

const ContactInfo = styled.div`
  margin: 25px 0 0 0;
`;

const ContactItem = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  padding: 8px 0;

  .contact-label {
    font-weight: bold;
    color: #333;
    min-width: 80px;
    margin-right: 15px;
    font-size: 14px;
  }

  .contact-value {
    color: #555;
    font-size: 14px;
  }

  @media (max-width: 480px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;

    .contact-label {
      min-width: auto;
      margin-right: 0;
    }
  }
`;















// import React from "react";
// import styled from "styled-components";

// export default function BlogBox({ tag, title, text, action, author }) {
//   return (
//     <WrapperBtn className="animate pointer" onClick={action ? () => action() : null}>
//       <Wrapper className="whiteBg radius8 shadow">
//         <h3 className="font20 extraBold">{title}</h3>
//         <p className="font13" style={{ padding: "30px 0" }}>
//           {text}
//         </p>
//         <p className="font13 extraBold">{author}</p>
//         <div className="flex">
//           <p className="tag coralBg radius6 font13 extraBold">{tag}</p>
//         </div>
//       </Wrapper>
//     </WrapperBtn>
//   );
// }

// const Wrapper = styled.div`
//   width: 100%;
//   text-align: left;
//   padding: 20px 30px;
//   margin-top: 30px;
// `;
// const WrapperBtn = styled.button`
//   border: 0px;
//   outline: none;
//   background-color: transparent;
//   :hover {
//     opacity: 0.5;
//   }
// `;
